import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { IPaginatedRequest } from '@cbgms/api'

export const listConversionStatus = (params: IPaginatedRequest) =>
  createAsyncApiAction('support', {
    method: 'GET',
    url: '/modules/shop-conversions/list-conversion-status',
    params
  })

export const listConversionFailedEntities = (params: IPaginatedRequest) =>
  createAsyncApiAction('support', {
    method: 'GET',
    url: '/modules/shop-conversions/list-failed-entities',
    params
  })
